import React, { useState } from 'react';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is defined in your config
import { useNavigate } from 'react-router-dom';

const AddContraEntry = () => {
    const [partyId, setPartyId] = useState('');
    const [drInAmount, setDrInAmount] = useState('');
    const [crInAmount, setCrInAmount] = useState('');
    const navigate = useNavigate();

    const handleSubmit = (event) => {
        event.preventDefault();

        const contraEntry = {
            party_id: partyId,
            dr_in_amount: drInAmount,
            cr_in_amount: crInAmount,
        };

        fetch(`${BASE_URL}contraentry`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(contraEntry),
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.status === 1) {
                    alert(data.message);
                    navigate('/ContraEntriesList'); // Assuming this is the route for listing contra entries
                } else {
                    alert('Error creating contra entry. Please try again.');
                }
            })
            .catch((error) => console.error('Error creating contra entry:', error));
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Add Contra Entry</h3>
                        </div>
                        <div className="col-12 col-md-6 order-md-2 order-first">
                            <nav aria-label="breadcrumb" className="breadcrumb-header float-start float-lg-end">
                                <ol className="breadcrumb"></ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            {/* Add Contra Entry Form */}
            <section className="section">
                <div className="row">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <h4 className="card-title">Add Contra Entry Details</h4>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="partyId" className="form-label">Party ID</label>
                                        <input
                                            type="number"
                                            id="partyId"
                                            className="form-control"
                                            value={partyId}
                                            onChange={(e) => setPartyId(e.target.value)}
                                            placeholder="Enter party ID"
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="drInAmount" className="form-label">Debit Amount</label>
                                        <input
                                            type="number"
                                            id="drInAmount"
                                            className="form-control"
                                            value={drInAmount}
                                            onChange={(e) => setDrInAmount(e.target.value)}
                                            placeholder="Enter debit amount"
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="crInAmount" className="form-label">Credit Amount</label>
                                        <input
                                            type="number"
                                            id="crInAmount"
                                            className="form-control"
                                            value={crInAmount}
                                            onChange={(e) => setCrInAmount(e.target.value)}
                                            placeholder="Enter credit amount"
                                            required
                                        />
                                    </div>
                                    <div className="text-end">
                                        <button type="submit" className="btn btn-primary">Add Contra Entry</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* End Add Contra Entry Form */}
        </div>
    );
};

export default AddContraEntry;
